import { render, staticRenderFns } from "./index.vue?vue&type=template&id=acb0ff7a&"
import script from "./controller.js?vue&type=script&lang=js&"
export * from "./controller.js?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports